import styled, { css } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { useBreakpoint } from '@hivebrite/design-system/Theme';

import { useGridContext } from 'hb-react/shared/components/DesignSystem/Grid/contexts/GridContext';

import Col from './Col';
import Row from './Row';

const bgColors = {
  s: '#faffd3',
  m: '#c9ffe1',
  l: '#ffd3f3',
  xl: '#d3f0ff',
};

export const GridHelper = () => {
  const { colGap, numCols } = useGridContext();
  const breakpoint = useBreakpoint();

  return (
    <WrapperGridHelper>
      <Row>
        {[...new Array(numCols)].map((_, index) => (
          <Col
            css={css`
              height: 100%;
            `}
            key={index}
          >
            <Box
              css={css`
                height: 100%;
                ${getColor({
                  colGap,
                  isFirst: index === 0,
                  color: bgColors[breakpoint],
                })}
              `}
              display="block"
            />
          </Col>
        ))}
      </Row>
    </WrapperGridHelper>
  );
};

const getColor = ({ colGap, isFirst, color }) => {
  if (colGap !== 0) {
    return css`
      background-color: ${color};
    `;
  }

  return css`
    ${isFirst && `border-left: 3px solid ${color}`};
    border-right: 3px solid ${color};
  `;
};

const WrapperGridHelper = styled.div`
  bottom: 0;
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
`;
